import router from "../../router";
import store from "../vuex/store";
import nprogress from "nprogress"; // Progress 进度条
import("nprogress/nprogress.css");

const whiteList = ["/login"]; // 不重定向白名单

// 如果（即将进入的这个路由需要权限才能进入）
/*
 *  前置路由守卫
 *   to:可以获取到你想跳的那个路由信息
 *   from：可以获取到你从那个路由而来的
 *   next:放行函数。next()、next(path)、next(false)
 */
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('TOKEN');
  nprogress.start();
  if(window.parent !== window) {
    getPath(to);
  }

  // 点击登录时，拿到了token并存入了cookie，保证页面刷新时，始终可以拿到token
  if (token) {
    if (to.path === "/login") {
      next();
      nprogress.done();
      // store.commit("SET_ROLES", []);
    } else {
      nprogress.done();
      // 用户登录成功之后，每次点击路由判断当前用户是否有roles信息
      if (store.getters.roles.length === 0) {
        try {
          let userList = { roles: [] };
          const account = JSON.parse(sessionStorage.getItem('ACCOUNT'));
          const {roleId} = account;

          userList.roles.push(roleId === '0' ? 'admin' : roleId === '1' ? '基本用户' : roleId === '2' ? '管理员' : '一般用户');

          store.commit("SET_ROLES", userList.roles);
          store.dispatch("GenerateRoutes", { roles: userList.roles }).then(() => {
            // 根据roles权限生成可访问的路由表
            for(let route of store.getters.addRouters) {
              router.addRoute(route);
            }
            // 在addRoute()之后第一次访问被添加的路由会白屏，这是因为刚刚addRoute()就立刻访问被添加的路由，然而此时addRoute()没有执行结束，因而找不到刚刚被添加的路由导致白屏。因此需要从新访问一次路由才行。
            next({ ...to, replace: true}); // hack方法 确保addRoutes已完成 将replace:true设置为true，以便导航不会留下历史记录,不可以点击node回退按钮。
          });
        } catch (err) {
          // 报错直接退出登录
          console.log(err);
          next({ path: "/login" });
        }
      } else {
        next();
      }
    }
  } else {
    // 未获取到token，进行处理，判断将要跳转的路由，判断是否为恶意进入或者单纯是退出登录
    if (whiteList.indexOf(to.path) !== -1) {
      // 点击退出登录时,会定位到这里
      store.commit("SET_ROLES", []);
      next();
    } else {
      next("/login");
      nprogress.done();
    }
  }

  if (to.path === '/push' || to.path === '/PUSH') {
    router.push({name: 'push'}, ()=> {})
  }
});

router.afterEach(() => {
  nprogress.done(); // 结束Progress
});

// 给通行证系统发当前路由信息
function getPath(to) {
  const projectInfo = window.session.getObj(window.sessionKeys.PROJECT) || {};
  const data = {
    type: 'ROUTE',
    path: to.path,
    otherQuery: projectInfo
  }
  window.parent.postMessage(data, 'http://monitor.szdatie.com:10214');
  window.parent.postMessage(data, 'http://localhost:5173');
}


// WEBPACK FOOTER //
// ./src/managers/utils/permission.js